module.exports = __webpack_public_path__ + "img/buy-kt-chuti.715d9fd4.jpg";